// extracted by mini-css-extract-plugin
export default {"divider":"Footnote_divider__Rq-kV"};